"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.motorAndDriveResults = exports.fanResults = void 0;
exports.fanResults = "fmptfanresults";
exports.motorAndDriveResults = "fmptmotoranddriveresults";
//# sourceMappingURL=result-group-names.js.map